(() => {
    "use strict";

    angular.module("app").controller("StoppedFvmScreeningsController", StoppedFvmScreeningsController);
    StoppedFvmScreeningsController.$inject = ["$scope", "notificationService", "webApiServices",
        "loadingIndicatorService", "ScreeningFunctions"
    ];
    function StoppedFvmScreeningsController($scope, notificationService, webApiServices,
        loadingIndicatorService, ScreeningFunctions) {
        $scope.PageNumber = 1;
        $scope.sortType = "RequestDate"; // set the default sort type
        $scope.sortReverse = true; // set the default sort order
        $scope.OpenScreening = openScreening;
        $scope.setPage = _setPage;

        function openScreening(screening) {
            $scope.OpenedScreening = screening;
            $scope.OpenedScreeningStatus = screening.Status;
            ScreeningFunctions.OpenScreening(screening);
        };

        function _setPage(page) {
            $scope.PageNumber = page.toString();
            search();
        };

        function search() {
            loadingIndicatorService.SetLoadingState(true);
            webApiServices.GetStoppedScreenings(
                { Filter: { PageNumber: $scope.PageNumber } },
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.Requests = result.data;
                    }
                },
                (err) => DoShowError(notificationService, err),
                () => loadingIndicatorService.SetLoadingState(false));
        };
        search();
    }
})();